import { TextKey } from '@mews-commander/enums';
import { ConvertedCurrencyValue, DividerList, LocalizedTypography } from '@mews-commander/ui';
import { Stack, Typography } from '@optimus-web/core';

import { usePaymentDetailsSidebarContext } from '../context/PaymentDetailsSidebarContext';
import { isFailedOrPendingPaymentStatus } from '../utils';
import { DccPaymentSection } from './DccPaymentSection';
import { PaymentMethodSection } from './PaymentMethodSection/PaymentMethodSection';
import { RelatedInfoSection } from './RelatedInfoSection/RelatedInfoSection';
import { TerminalDetailsSection } from './TerminalDetailsSection';
import { TransactionDetailsSection } from './TransactionDetailsSection';

export const PaymentDetailsSidebarContent = () => {
    const { paymentDetails, receipt, paymentPlanId, paymentPlanName } = usePaymentDetailsSidebarContext();
    const { dccPaymentDetail, serviceOrderId, serviceOrderNumber, billDetails, status, amount } = paymentDetails ?? {};

    const hasReservation = !!serviceOrderId && !!serviceOrderNumber;
    const hasBill =
        !!billDetails?.billId && !!billDetails?.billName && status && !isFailedOrPendingPaymentStatus(status);
    const hasPaymentPlan = !!(paymentPlanId && paymentPlanName);
    const hasRelatedInfo = hasReservation || hasBill || hasPaymentPlan;

    return (
        <Stack vertical spacing="400">
            <DividerList spacing="300">
                <Stack vertical spacing="100">
                    <LocalizedTypography
                        textStyle="bodyLargeStrong"
                        variant="tertiary"
                        textKey={TextKey.GeneralAmountPrice}
                        as="div"
                    />
                    <Typography textStyle="highlightMedium" as="div">
                        <ConvertedCurrencyValue amount={amount} />
                    </Typography>
                </Stack>

                <TransactionDetailsSection />
                {dccPaymentDetail && <DccPaymentSection />}
                {receipt && <TerminalDetailsSection />}
                <PaymentMethodSection />
                {hasRelatedInfo && <RelatedInfoSection />}
            </DividerList>
        </Stack>
    );
};
